import { vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { id: "pegman-wrapper" }
const _hoisted_2 = {
  id: "pegman",
  class: "pegman-standing"
}
const _hoisted_3 = { id: "pegman-pano" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  id: "pegman-unavailable"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_StreetView = _resolveComponent("StreetView")!
  const _component_AppDialog = _resolveComponent("AppDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.image)
          ? _withDirectives((_openBlock(), _createElementBlock("img", {
              key: 0,
              onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.endPanoLoad && $options.endPanoLoad(...args))),
              src: _ctx.image,
              alt: "Street View Image"
            }, null, 40, _hoisted_4)), [
              [_vShow, !$setup.panoLoading]
            ])
          : _createCommentVNode("", true),
        (!_ctx.image && !$setup.panoLoading && _ctx.unavailable && false)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t("message.unavailable")), 1))
          : _createCommentVNode("", true)
      ]),
      (!$setup.pegman.dragging)
        ? (_openBlock(), _createBlock(_component_v_icon, {
            key: 0,
            class: "pegman-icon"
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("mdi-human", -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true),
      ($setup.pegman.dragging)
        ? (_openBlock(), _createBlock(_component_v_icon, {
            key: 1,
            class: "pegman-icon"
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("mdi-human-handsup", -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_AppDialog, {
      show: $setup.pegman.show,
      onShowChanged: _cache[2] || (_cache[2] = ($event: any) => ($options.closeStreetView()))
    }, {
      title: _withCtx(() => [...(_cache[5] || (_cache[5] = [
        _createTextVNode(" StreetView ", -1)
      ]))]),
      content: _withCtx(() => [
        ($setup.pegman.show)
          ? (_openBlock(), _createBlock(_component_StreetView, {
              key: 0,
              ref: "streetView",
              manValue: $setup.pegman,
              onClose: _cache[1] || (_cache[1] = ($event: any) => ($options.closeStreetView()))
            }, null, 8, ["manValue"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}